import type { SVGProps } from "react";
export interface Paste02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Paste02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Paste02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m15.926 20.875.115.005a1.126 1.126 0 0 1 0 2.239l-.115.006h-2.024a1.125 1.125 0 1 1 0-2.25zm-8.301-1.96a1.125 1.125 0 0 1 1.392.58l.044.105.083.198c.187.385.5.699.885.886l.198.082.107.044a1.125 1.125 0 0 1-.746 2.11l-.111-.033-.219-.083a4.17 4.17 0 0 1-2.234-2.234l-.085-.22-.033-.11a1.126 1.126 0 0 1 .719-1.325m13.141.685a1.125 1.125 0 0 1 2.121.75 4.17 4.17 0 0 1-2.537 2.537 1.125 1.125 0 1 1-.75-2.12 1.92 1.92 0 0 0 1.166-1.167m.109-3.674v-2.024a1.125 1.125 0 0 1 2.25 0v2.024a1.125 1.125 0 0 1-2.25 0m-1.96-8.301c.194-.55.771-.854 1.325-.72l.11.034.22.085a4.17 4.17 0 0 1 2.234 2.234l.083.219.034.11a1.125 1.125 0 0 1-2.11.747l-.045-.107-.082-.198a1.93 1.93 0 0 0-.886-.885l-.198-.083-.107-.044a1.125 1.125 0 0 1-.578-1.392M14.874 5a1.874 1.874 0 0 0-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v8c0 1.035.84 1.874 1.875 1.874h8a1.874 1.874 0 0 0 1.874-1.875zm2.25 8A4.125 4.125 0 0 1 13 17.124H5a4.125 4.125 0 0 1-4.125-4.126V5A4.125 4.125 0 0 1 5 .875h8A4.125 4.125 0 0 1 17.124 5z"
      />
    </svg>
  );
}
